import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import { useAppGameDetailsSelector, useAppTvImageSelector } from "src/_common/hooks/selectors/eventSelector";
import {
  APPLICATION_GLOBAL_SLUG,
  removeEmptyObjectKey,
  removeTrailingZero,
  SOCKET_CHANNEL,
  SOCKET_URL,
} from "src/_config";
import useSocket from "use-socket.io-client";

interface RPRodeoTvImageProps {
  globalTvData: any;
  socketChannel: any;
  setGlobalTvData: Function;
  setSocketChannel: Function;
  rodeoEventId: any;
}

export function RodeoTvImageComponent({
  globalTvData,
  socketChannel,
  setGlobalTvData,
  setSocketChannel,
  rodeoEventId,
}: RPRodeoTvImageProps) {
  const eventApi = useEventApi();
  // const tvImageSelector = useAppTvImageSelector()
  const { gameId } = useParams<any>();
  const [isInitialLoad, setIsInitialLoad] = useState<boolean>(false);
  const [isShowingAdsPromotion, setIsShowingAdsPromotion] = useState<boolean>(false);
  const [addPromotionImage, setAddPromotionImage] = useState<any>(null);
  const [adPromotionText, setAdPromotionText] = useState<any>(null);
  const [defaultAdsPromotionTime, setDefaultAdsPromotionTime] = useState<number>(1000);
  const gameDetails = useAppGameDetailsSelector();
  const [tvLeaderboardType, setTvLeaderboardType] = useState<any>(0);
  const [tvLeaderboardList, setTvLeaderboardList] = useState<any>();
  const [tvImageSelector, setTvImageSelector] = useState<any>();
  const [previousParams, setPreviousParams] = useState<any>();
  const [randomDrawNo, setRandomDrawNo] = useState<any>("");

  const getTvImageDetails = (screen1: string, type: any, globalDataType?: any) => {
    const params = {
      screen1,
      type,
    };
    console.log({ params });
    setPreviousParams({ ...params, globalTvData: globalDataType ? { type: globalDataType } : globalTvData });
    eventApi.callTvImageDetails(
      removeEmptyObjectKey(params),
      (message: string, resp: any) => {
        console.log({ resp });
        setTvImageSelector(resp);
        if (resp && globalTvData) {
          let x = resp?.rodeo_event_game_info?.tv_show_leaderboard;
          setTvLeaderboardType(x);
          // if (globalTvData?.type == "rodeo_event" || globalDataType == "rodeo_event") {
          //   let players: any = resp?.players;
          //   players?.map((p: any) => {
          //     p["name"] = p?.user_details?.display_name || p?.user_details?.full_name;
          //     p["avatar"] =
          //       p?.user_details?.avatar?.id != 0 ? p?.user_details?.avatar?.original : "/images/no-image.png";
          //     p["value_to_show"] = (p?.total_win || 0) + "/" + resp?.events_count;
          //     p["tie_breaker_code"] = p?.user_tie_total || 0;
          //     setRandomDrawNo(p["per_tie_total"]);
          //     return p;
          //   });
          //   setTvLeaderboardList(players);
          // } else if (globalTvData?.type == "rodeo_event_overall" || globalDataType == "rodeo_event_overall") {
          //   let events: any = resp?.events;
          //   events?.map((e: any) => {
          //     e["name"] = e?.event_name;
          //     e["avatar"] =
          //       e?.truck?.event_truck?.id != 0
          //         ? e?.truck?.event_truck?.original
          //         : e?.truck?.rodeo_pick_event?.avatar?.id != 0
          //         ? e?.truck?.rodeo_pick_event?.avatar?.original
          //         : "/images/no-image.png";
          //     e["value_to_show"] = e?.total_win || 0;
          //     return e;
          //   });
          //   setRandomDrawNo("");
          //   setTvLeaderboardList(events);
          // } else if (globalTvData?.type == "performance" || globalDataType == "performance") {
          //   let players: any = resp?.players;
          //   players?.map((p: any) => {
          //     p["name"] = p?.user_details?.display_name || p?.user_details?.full_name;
          //     p["avatar"] =
          //       p?.user_details?.avatar?.id != 0 ? p?.user_details?.avatar?.original : "/images/no-image.png";
          //     p["value_to_show"] = (p?.total_win || 0) + "/" + resp?.events_count;
          //     p["tie_breaker_code"] = p?.user_tie_total || 0;
          //     return p;
          //   });
          //   setRandomDrawNo(resp?.performance_dtls?.tie_breaker_code || "");
          //   setTvLeaderboardList(players);
          // } else if (globalTvData?.type == "performance_overall" || globalDataType == "performance_overall") {
          //   let events: any = resp?.events;
          //   events?.map((e: any) => {
          //     e["name"] = e?.event_name;
          //     e["avatar"] =
          //       e?.truck?.event_truck?.id != 0
          //         ? e?.truck?.event_truck?.original
          //         : e?.truck?.rodeo_pick_event?.avatar?.id != 0
          //         ? e?.truck?.rodeo_pick_event?.avatar?.original
          //         : "/images/no-image.png";
          //     e["value_to_show"] = e?.total_win || 0;
          //     return e;
          //   });
          //   setRandomDrawNo("");
          //   setTvLeaderboardList(events);
          // } else {
          //   let riders: any = resp?.riders;
          //   riders?.map((r: any) => {
          //     r["name"] = r?.name;
          //     r["avatar"] =
          //       r?.rider?.id != 0
          //         ? r?.rider?.original
          //         : r?.contestant_dtls?.avatar?.id != 0
          //         ? r?.contestant_dtls?.avatar?.original
          //         : "/images/no-image.png";
          //     r["value_to_show"] = removeTrailingZero(r?.vote) + " %";
          //     return r;
          //   });
          //   // console.log({riders})
          //   setRandomDrawNo("");
          //   setTvLeaderboardList(riders);
          // }
          let answers: any = resp?.answers;
          answers?.map((p: any) => {
            p["name"] = p?.user_details?.display_name || p?.user_details?.full_name;
            p["avatar"] = p?.user_details?.avatar?.id != 0 ? p?.user_details?.avatar?.original : "/images/no-image.png";
            p["value_to_show"] = p?.total_point || 0;
            // p["tie_breaker_code"] = p?.user_tie_total || 0;
            // setRandomDrawNo(p["per_tie_total"]);
            return p;
          });
          setTvLeaderboardList(answers);
        }
      },
      (message: string) => {
        console.error(`Error at API Access => ${message}`);
      }
    );
    // }
  };

  const getGameDetails = () => {
    let params = {
      slug: APPLICATION_GLOBAL_SLUG,
    };
    eventApi.callGetGameDetails(
      params,
      (message: any, resp: any) => {
        // console.log({resp})
      },
      (message: any) => {}
    );
  };

  const resetCssStyle = (type: any) => {
    var element = document.getElementById("rodeo_body");
    if (element) {
      if (["leaderboard", "ad"].includes(type)) {
        element.style.padding = "0 30px";
        element.style.paddingTop = "2.5em";
      } else {
        element.style.padding = "0px";
      }
    }
  };

  // const resetCssStyle = () => {
  //     var element = document.getElementById('rodeo_body');
  //     if (element) {
  //         element.style.paddingTop = '2.5em'
  //     }
  // }

  //Socket Implementation start here
  const [socket] = useSocket(SOCKET_URL, {
    autoConnect: false,
    transports: ['websocket', 'polling'], // Prefer websocket, fallback to polling
    upgrade: true,
    rememberUpgrade: true,
  });

  //Reset Reducer data after component unmount
  useEffect(() => {
    return () => {};
  }, []);

  useEffect(() => {
    console.log({ globalTvData, rodeoEventId });
    if (globalTvData && socketChannel && globalTvData?.rodeo_event_id == rodeoEventId) {
      resetCssStyle("landing");

      switch (socketChannel) {
        case SOCKET_CHANNEL.TV_BOARD_IMAGE:
          if (globalTvData.type == "rodeo_event") {
            getTvImageDetails(globalTvData.rodeo_event_id, "N");
            resetCssStyle("leaderboard");
            // resetCssStyle()
            setIsShowingAdsPromotion(false);
            setIsInitialLoad(false);
          } else if (globalTvData.type == "RodeoEvent") {
            getTvImageDetails(globalTvData.rodeo_event_id, "OE");
            resetCssStyle("leaderboard");
            // resetCssStyle()
            setIsShowingAdsPromotion(false);
            setIsInitialLoad(false);
          } else if (globalTvData.type == "performance") {
            getTvImageDetails(`${globalTvData.rodeo_event_id}||${globalTvData.performance_id}`, "N");
            resetCssStyle("leaderboard");
            // resetCssStyle()
            setIsShowingAdsPromotion(false);
            setIsInitialLoad(false);
          } else if (globalTvData.type == "performance_overall") {
            getTvImageDetails(`${globalTvData.rodeo_event_id}||${globalTvData.performance_id}`, "OE");
            resetCssStyle("leaderboard");
            // resetCssStyle()
            setIsShowingAdsPromotion(false);
            setIsInitialLoad(false);
          } else if (globalTvData.type == "Event") {
            getTvImageDetails(
              `${globalTvData.rodeo_event_id}||${globalTvData.performance_id}||${globalTvData.rodeo_event_event_id}`,
              "N"
            );
            resetCssStyle("leaderboard");
            // resetCssStyle()
            setIsShowingAdsPromotion(false);
            setIsInitialLoad(false);
          } else {
            resetCssStyle("landing");
            getTvImageDetails(gameId, null);
            setIsInitialLoad(true);
          }

          break;

        case SOCKET_CHANNEL.ADV_PROMOTION:
          resetCssStyle("ad");
          setIsInitialLoad(false);

          setIsShowingAdsPromotion(true);
          setAddPromotionImage(globalTvData.image);
          setAdPromotionText(globalTvData.text);
          setDefaultAdsPromotionTime(globalTvData.default_timeout);
          break;

        case SOCKET_CHANNEL.CONTESTANT_WINNER:
          resetCssStyle("leaderboard");
          let screen = "";
          if (previousParams?.type) {
            let prevParms = previousParams?.screen1?.split("||");
            // console.log({prevParms})
            if (globalTvData.rodeo_event_id && prevParms.length > 0) {
              screen = screen + globalTvData.rodeo_event_id;
              if (globalTvData.performance_id && prevParms.length > 1) {
                screen = screen + "||" + globalTvData.performance_id;
                if (globalTvData.rodeo_event_event_id && prevParms.length > 2) {
                  screen = screen + "||" + globalTvData.rodeo_event_event_id;
                }
              }
            }
            if (screen) {
              getTvImageDetails(screen, previousParams?.type, previousParams?.globalTvData?.type);
            }
          }
          // else {
          //     screen = previousParams?.screen1
          // }
          // console.log({previousParams, screen})
          break;
      }
      setGlobalTvData(null);
      setSocketChannel(null);
    }
  }, [globalTvData, socketChannel]);

  useEffect(() => {
    getTvImageDetails(gameId, null);
    getGameDetails();
    setIsInitialLoad(true);
    var element = document.getElementById("rodeo_body");
    if (element) {
      element.style.paddingTop = "0px";
      element.style.marginBottom = "0px";
      element.style.backgroundColor = "#fff";
      // element.style.backgroundImage = 'none'
    }
  }, []);

  return (
    <React.Fragment>
      {isInitialLoad ? (
        <div
          className="main-bg"
          style={{
            backgroundImage: `url("${"/images/tv/tv-screen-blank1.jpg"}")`,
            position: "fixed",
            width: "100%",
            height: "100%",
            backgroundSize: "100% 100%",
            backgroundRepeat: "no-repeat",
          }}
        ></div>
      ) : (
        <>
          <div
            className="main-bg"
            style={{
              backgroundColor: "#000",
              position: "fixed",
              width: "100%",
              height: "100%",
              left: 0,
              top: 0,
              zIndex: -1,
              overflowX: "hidden",
              margin: 0,
            }}
          ></div>
          <section className="container" style={{ maxWidth: "100%" }}>
            <div className="logobar ">
              <div className="border-div" />
              <div className="border-div2" />
              <div className="logo_left_txt">
                {isShowingAdsPromotion && adPromotionText
                  ? adPromotionText
                  : `${tvImageSelector?.rodeo_event_dtls?.title ? tvImageSelector.rodeo_event_dtls.title : "--"}${
                      tvImageSelector?.performance_dtls?.title ? " :: " + tvImageSelector?.performance_dtls?.title : ""
                    }${
                      tvImageSelector?.event_dtls?.event_title ? " :: " + tvImageSelector?.event_dtls?.event_title : ""
                    }`}
              </div>
              <div className="logo_image">
                <img src={gameDetails?.logo?.original} className="img-responsive" />
              </div>
            </div>

            <div className={"heading_text " + (randomDrawNo ? "my-3" : "")}>
              {tvImageSelector && tvImageSelector.event_dtls && tvImageSelector.event_dtls.sponsor
                ? `SPONSORED BY ${tvImageSelector.event_dtls.sponsor.title}`
                : null}
              {randomDrawNo ? (
                <div className="text-center text-white" style={{ fontSize: "20px" }}>
                  RANDOM DRAW NUMBER (to be used for tie breaker): {randomDrawNo}
                </div>
              ) : null}
            </div>
            <div className="clearfix">
              {!isShowingAdsPromotion ? (
                <ul className="tv-list">
                  {
                    // tvImageSelector && tvImageSelector.riders && tvImageSelector.riders.length ?
                    //     tvImageSelector.riders.slice(0, tvImageSelector && tvImageSelector.limit ? tvImageSelector.limit : 10).map((riders: any) => (
                    tvLeaderboardList && tvLeaderboardList?.length ? (
                      tvLeaderboardList
                        ?.slice(0, tvImageSelector && tvImageSelector.limit ? tvImageSelector.limit : 10)
                        .map((item: any) => (
                          <li key={item.id}>
                            <div className="left_sec">
                              <div className="border-div"></div>
                              <div className="curve-bg">
                                <div className="left_sec_l">
                                  {/* {item.avatar ? (
                                    <span className="event-img tv-avatar">
                                      <img src={item.avatar} />
                                    </span>
                                  ) : null} */}
                                  <div>{item.name}</div>
                                </div>
                                {/* <div className="left_sec_r">{removeTrailingZero(item.vote)} %</div> */}
                                <div className={"left_sec_r " + (item.tie_breaker_code ? "lucky" : "")}>
                                  {item.value_to_show}
                                </div>
                                {item.tie_breaker_code ? (
                                  <div className="left_sec_r left_sec_r_code">
                                    {"(" +
                                      (item.tie_breaker_code == 99999 || item.tie_breaker_code == 9999999
                                        ? "-"
                                        : item.tie_breaker_code) +
                                      ")"}
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </li>
                        ))
                    ) : (
                      <div className="text-center" style={{ color: "#fff" }}>
                        <p>No Results published yet!</p>
                      </div>
                    )
                  }
                </ul>
              ) : (
                <div className="tv-ads-promotion">
                  <img
                    // className="w-100"
                    src={addPromotionImage}
                    alt="image"
                  />
                </div>
              )}
            </div>
          </section>
        </>
      )}
    </React.Fragment>
  );
}
